export const CURRENT_LEVEL_FALLBACK = "your current Level"

export const ACCEPTABLE_PROGRESS_REAPPLY_REQUIREMENT_NAME =
  "Reapply to the Associate Program"

export const getAcceptableProgressTerminatedStandingCopy = (
  currentLevelName,
  { levelComplete = false, pathNeutral = false } = {},
) => {
  const destination = pathNeutral
    ? "Re-Register"
    : "Re-Register for the Associate Program"
  const reapplyTarget = pathNeutral
    ? "reapply"
    : "reapply to the Associate Program"

  if (levelComplete) {
    if (pathNeutral) {
      return "You are currently Terminated due to failure to meet Acceptable Progress. You must reapply in order to purchase your next Level."
    }

    return `You are currently Terminated due to failure to meet Acceptable Progress. In order to ${destination}, you must ${reapplyTarget}.`
  }

  const level = currentLevelName || CURRENT_LEVEL_FALLBACK

  return `You are currently Terminated due to failure to meet Acceptable Progress. In order to ${destination}, you must complete all requirements of ${level} and ${reapplyTarget}.`
}

export const getAcceptableProgressReapplyRequirementCopy = ({
  levelComplete = false,
} = {}) =>
  levelComplete
    ? "Reapply to the Associate Program."
    : "Complete all requirements of your current Level, then reapply to the Associate Program."

export const getAcceptableProgressPurchaseLockedCopy = (
  nextLevelName,
  { levelComplete = false } = {},
) =>
  levelComplete
    ? `Please successfully reapply as an Associate to purchase ${nextLevelName}.`
    : `Please complete all requirements of your current Level and successfully reapply as an Associate to purchase ${nextLevelName}.`
